import { Routes } from '@angular/router';

import { merge } from '../internals/merge';
import { getSpecDefaultOptions, SpecOptions } from '../Spec/options';
import { OptionalsRequired } from '../types';

import { RouteOptions } from './route-options';

export type SpecRoutingOptions<C> = SpecOptions<C> &
  RouteOptions & {
    mockRouterLinks?: boolean;
    stubsEnabled?: boolean;
    routes?: Routes;
  };

const defaultRoutingOptions: OptionalsRequired<SpecRoutingOptions<any>> = {
  ...getSpecDefaultOptions(),
  params: {},
  queryParams: {},
  data: {},
  fragment: null,
  mockRouterLinks: true,
  stubsEnabled: true,
  routes: [],
  url: [],
  root: null,
  parent: null,
  children: null,
  firstChild: null
};

/**
 * @internal
 */
export function getRoutingDefaultOptions<S>(overrides: SpecRoutingOptions<S>): Required<SpecRoutingOptions<S>> {
  return merge(defaultRoutingOptions, overrides);
}
